<template>
  <div class="web-box-all">
    <ext-header></ext-header>

    <div class="web-home-main">
      <div class="web-order-state">
        <h2>
          订单编号：{{order_info.erp_order_no!='' ? order_info.erp_order_no : order_info.order_no}}
        </h2>
        <h3>退货注意事项</h3>
        <p v-html="order_return_info"></p>
      </div>

      <div class="web-order-main">

        <div class="web-order-address">
            <h2>餐厅名称：{{order_info.store_name}}</h2>
            <ul>
                <li v-if="order_info.market_name">
                    <p>所属市场：{{order_info.market_name}}</p>
                </li>
                <li v-if="order_info.store_no">
                    <p>门店编号：{{order_info.store_no}}</p>
                </li>
                <li v-if="order_info.zoneNo">
                    <p>国际编码：{{order_info.zoneNo}}</p>
                </li>
                <li v-if="order_info.market_name">
                    <p>餐厅电话：{{order_info.store_phone}}</p>
                </li>
                <li v-if="order_info.user_phone">
                    <p>联系电话：{{order_info.user_phone}}</p>
                </li>
                <li v-if="order_info.store_address">
                    <p>餐厅地址：{{order_info.store_address}}</p>
                </li>
            </ul>
        </div>
        <div class="web-order-address-line"></div>

        <div class="web-order-info-title">
            <h2>选择退货原因</h2>
            <p>
              <b-form-select v-model="return_class" :options="return_class_list" disabled-field="请选择退货原因" style="padding:3px;"></b-form-select>
            </p>
        </div>

        <div class="web-order-info-title">
            <h2>退货原因</h2>
            <b-form-textarea
                id="textarea"
                v-model="return_remark"
                placeholder="请描述申请退货的具体原因"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
        </div>

        <div class="web-order-info-image">
            <h2>图片</h2>
            <ul>
              <li v-if="image_list.length<6">
                <img @click="add_image()" src="@/assets/add_2icon.png"/>
                <div style="width:1px;height:1px;  overflow: hidden; ">
                  <form id="fileForm" enctype="multipart/form-data" class="form-horizontal " >
                    <input id="get_upload" class="form-control" type="file" name="file" @change="handleFileChange">
                  </form>
                </div>
              </li>
              <li v-for="(vo,index) in image_list" :key="index">
                <img src="@/assets/goods_load.png" v-real-img="web_url+vo.img"/>
                <a>
                  <img style="display:none;" src="@/assets/icon/img_1.png" @click="img_show(index,vo.img)"/>
                  <img src="@/assets/icon/img_2.png" @click="img_del(index)" />
                </a>
              </li>
            </ul>
        </div>

        <div class="web-order-info-title" style="border:0px;">
            <h2>请选择退货商品</h2>
        </div>

        <div class="web-order-goods-box">

            <div v-for="(vo,index) in goods_list" :key="index" class="web-cart-list-data">
                <div class="web-cart-list-checkbox">
                  <label>
                    <div class="web-cart-list-checkbox-input">
                      <input type="checkbox" v-model="vo.checked" :data-index="index" @change="checked_select"  />
                    </div>
                  </label>
                  <img @click="get_goods_show(vo.goods_no)" src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
                </div>
                <div class="web-cart-list-goods">
                    <p>{{vo.goods_name}}</p>
                    <a>{{vo.goods_no}}</a>
                </div>
                <div class="web-cart-list-props"></div>
                <div class="web-cart-list-price">
                  <p>￥{{vo.price}} x {{vo.qty}}</p>
                </div>
                <div class="web-cart-list-quantity">
                  <p>
                    <a @click="cart_del(index)">-</a>
                    <input type="number" v-model.number="vo.qty" :data-index="index" data-type="spot" @blur.capture="input_out"/>
                    <a @click="cart_add(index)">+</a>
                  </p>
                </div>
            </div>

        </div>

      </div>

      <div class="web-order-footer">
        <ul>
            <li>
                <p>商品合计：</p>
                <a>￥{{sum_goods_money}}</a>
            </li>
        </ul>
        <ul class="money">
            <li>
                <p>应退金额：</p>
                <a class="red">{{return_fee}}</a>
            </li>
           <li>
                <a><span class="select" v-if="order_info.order_state>2">(仅供参考)</span></a>
            </li>
        </ul>
        <h2>
          <a id="post_data" @click="post_data()" class="red">申请退货</a>
        </h2>
      </div>
    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl, upload} from '@/utils/extend'
import $ from 'jquery'
import Toast from '@/components/toast/index'

export default {
  name: 'sales_return',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '订单详情',
      web_url: webUrl(),
      pay_win_state: 0,
      header_title: '',
      order_no: '',
      return_class: '',
      return_class_list: [],
      order_return_info: '',
      return_remark: '',
      image_width: 0,
      sum_goods_money: '0.00',
      return_integral: '0.00',
      return_fee: 0,
      up_return_state: false,
      order_info: {},
      goods_list: [],
      image_list: [],
      toast_state: 'display:none',
      toast_text: ''
    }
  },
  mounted () {
    var params = this.$route.query
    var orderNo = Decrypt(params.v)

    this.load_data(orderNo)
    this.get_return_class()
    this.load_order_goods(orderNo)
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    checked_select (event) {
      var that = this
      var index = event.target.dataset['index']
      var checked = event.target.checked
      this.goods_list[index].checked = checked

      this.up_return_fee()
    },
    input_out (e) {
      var input = e.target._value
      var index = e.target.dataset['index']
      if (input) {
        var qtyMax = this.goods_list[index].qty_max
        if (input < qtyMax) {
          this.$set(this.goods_list[index], 'qty', input)
        } else {
          this.$set(this.goods_list[index], 'qty', qtyMax)
        }
        this.up_return_fee()
      }
    },
    cart_del (index, name) {
      var setQty = 0
      var qty = 0
      qty = this.goods_list[index].qty
      if (qty > 1) {
        setQty = parseInt(qty) - 1
        this.$set(this.goods_list[index], 'qty', setQty)
      } else {
        setQty = 1
        this.$set(this.goods_list[index], 'qty', setQty)
      }

      this.up_return_fee()
    },
    cart_add (index) {
      var qty = this.goods_list[index].qty
      var qtyMax = this.goods_list[index].qty_max
      if (qty < qtyMax) {
        this.$set(this.goods_list[index], 'qty', parseInt(qty) + 1)
      } else {
        this.$set(this.goods_list[index], 'qty', qtyMax)
      }
      this.up_return_fee()
    },
    load_order_goods (orderNo) {
      var that = this
      ajax({
        url: '/store/order/order_return_goods',
        method: 'post',
        data: {
          uid: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.goods_list = ret.data
          that.up_return_fee()
        }
      })
    },
    up_return_fee () {
      var that = this
      var goodsList = this.goods_list
      var sumGoodsMoney = 0
      var returnIntegral = 0
      if (goodsList) {
        goodsList.forEach(function (val) {
          if (val.checked === true) {
            sumGoodsMoney += parseInt(val['qty']) * parseFloat(val['price'])
            returnIntegral += parseInt(val['qty']) * parseFloat(val['integral'])
          }
        })

        if (sumGoodsMoney > 0) {
          that.up_return_state = true
        } else if (returnIntegral > 0) {
          that.up_return_state = true
        } else {
          that.up_return_state = false
        }

        that.sum_goods_money = sumGoodsMoney.toFixed(2)
        that.return_integral = returnIntegral
        that.return_fee = sumGoodsMoney.toFixed(2)
      }
    },
    add_image () {
      $('#get_upload').trigger('click')
    },
    img_show (index, img) {

    },
    img_del (index) {
      this.image_list.splice(index, 1)
    },
    handleFileChange (e) {
      var vm = this
      let file = e.target.files[0]
      let supportedTypes = ['image/jpg', 'image/jpeg', 'image/png']
      if (file && supportedTypes.indexOf(file.type) >= 0) {
        const param = new FormData()
        param.append('uid', getUserId())
        param.append('file', file)

        upload({
          url: '/store/upload/file_upload',
          method: 'post',
          data: param
        }, function (ret) {
          if (ret && ret.code === 'success') {
            vm.toast(ret.msg)
            var getList = vm.image_list
            getList.push({
              img: ret.data.url
            })
            vm.image_list = getList
          } else {
            vm.toast(ret.msg)
          }
        })
      } else {
        vm.toast('文件格式只支持：jpg、jpeg 和 png')
      }
    },
    set_return_class (str) {
      this.return_class = str
    },
    load_user () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.user_info = ret.data
        }
      })
    },
    get_return_class () {
      var that = this
      ajax({
        url: '/store/api/select_return',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          var ListArr = []
          var list = ret.data
          list.forEach(function (val) {
            ListArr.push({
              'value': val,
              'text': val
            })
          })
          that.return_class_list = ListArr
          that.return_class = ret.data['0']
        }
      })
    },
    load_data (orderNo) {
      var that = this
      ajax({
        url: '/store/order/order_show',
        method: 'post',
        data: {
          uid: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.order_no = orderNo
          that.header_title = ret.data.order_info.order_state_name
          that.order_info = ret.data.order_info
        }
      })

      ajax({
        url: '/store/order/order_return_info',
        method: 'post',
        dataType: 'text',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        that.order_return_info = ret
      })
    },
    verify_post (type) {
      if (type === true) {
        $('#post_data').css({'background': '#cccccc'})
      } else {
        $('#post_data').css({'background': '#d81e06'})
      }
    },
    post_data () {
      var that = this
      var returnClass = this.return_class

      if (!returnClass || returnClass === '') {
        that.toast('请选择退货原因')
        return false
      } else {
        var goodsList = this.goods_list
        var selectGoods = []

        goodsList.forEach(function (val) {
          if (val.checked === true) {
            selectGoods.push(val)
          }
        })

        if (selectGoods.length === 0) {
          that.toast('请选择一个商品')
          return false
        }

        that.verify_post(true)

        if (that.up_return_state === true) {
          var returnRemark = this.return_remark
          var imgList = this.image_list

          that.up_return_state = false
          ajax({
            url: '/store/order/post_return_order',
            method: 'post',
            data: {
              uid: getUserId(),
              order_no: that.order_no,
              select_return: returnClass,
              return_remark: returnRemark,
              select_goods: JSON.stringify(selectGoods),
              goods_money: that.sum_goods_money,
              return_integral: that.return_integral,
              return_fee: that.return_fee,
              img_1: imgList[0] ? imgList[0].img : '',
              img_2: imgList[1] ? imgList[1].img : '',
              img_3: imgList[2] ? imgList[2].img : '',
              img_4: imgList[3] ? imgList[3].img : '',
              img_5: imgList[4] ? imgList[4].img : '',
              img_6: imgList[5] ? imgList[5].img : ''
            }
          }, function (ret) {
            that.verify_post(false)
            that.up_return_state = true
            if (ret && ret.code === 'success') {
              that.toast(ret.msg)
              setTimeout(function () {
                that.$router.push({path: '/order/order_list', query: {}})
              }, 1500)
            } else {
              that.toast(ret.msg)
            }
          })
        }
      }
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-state { width:100%; height:auto; margin-top:15px; flex-wrap:wrap; align-content:flex-start; border:1px solid #dfdfdf; }
    .web-order-state h2 { width:100%; height:50px;  margin:0px;line-height:50px; font-size:14px; font-weight: bold; border-left:3px solid #d81e06; justify-content:space-between; padding:0px 20px;color:#333333;}
    .web-order-state h3 { width:100%; height:40px;  margin:0px;line-height:40px; font-size:12px; font-weight: bold; justify-content:space-between; padding:0px 20px; color:#333333;}
    .web-order-state p { width:100%; height:auto; margin:0px 0px 15px 0px; font-weight: normal; padding:0px 20px; line-height:30px; font-size:12px; color:#333333; }

.web-order-main { width:100%; height:auto; padding:20px; margin-top:15px; border:1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-address ul { width:100%; height:auto; list-style:none; margin:0px; padding:0px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
    .web-order-address ul li { width:50%; height:30px; margin:0px; padding:0px;}
    .web-order-address ul li p { width:100%; height:30px; margin:0px; padding:0px; line-height:30px; font-size:12px; color:#333333;}
    .web-order-address-line { width:100%; height:5px; margin-top:15px; background-size: auto 100%; background-image:url('../../assets/icon/order_address_line.png'); background-repeat : repeat-x;}

.web-order-info-title { width:100%; height:auto; margin-top:10px; border-bottom: 1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-info-title h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-info-title p { width:100%; height:30px; line-height:30px; font-size:14px; }
    .web-order-info-title p div.custom-radio { cursor: pointer;}
    .web-order-info-title h2 span { font-size:12px; color:#666666; font-weight: normal; margin-left:20px;}
    .web-order-info-title textarea { margin-bottom: 15px;}
  .web-cart-list-checkbox label { width:auto; height:auto; cursor: pointer; position: relative; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-checkbox { width:140px; height:auto;  -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; line-height:40px; font-size:12px; color:#333333;}

  .web-cart-list-checkbox-input { width:20px; height:100%; line-height:40px; position: relative; margin:0px 10px 0px 10px; font-size:12px; color:#333333;}
  .web-cart-list-checkbox-input input { width:18px; height:18px; position: absolute; top:50%; left:1px; margin-top:-9px; padding:0px; font-size:12px; color:#333333;}

.web-order-info-image { width:100%; height:auto; margin-top:10px; overflow: hidden; border-bottom: 1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-info-image h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-info-image p { width:100%; height:30px; line-height:30px; font-size:14px; }
    .web-order-info-image p div.custom-radio { cursor: pointer;}
    .web-order-info-image h2 span { font-size:12px; color:#666666; font-weight: normal; margin-left:20px;}
    .web-order-info-image ul { width:100%; height:140px; margin:0px; padding:0px; list-style: none; flex-flow:row; align-content:flex-start;}
    .web-order-info-image ul li { width:120px; height:120px; overflow: hidden; position:relative; border:1px solid #dfdfdf; overflow: hidden; margin:5px; cursor: pointer;}
    .web-order-info-image ul li img { width:120px; height:120px; object-fit: cover;}
    .web-order-info-image ul li a { width:120px; height:120px; padding:45px 0px; display: none; justify-content:center; position: absolute; left:0px; top:0px; background: rgba(0,0,0,0.5);}
    .web-order-info-image ul li a img { width:30px; height:30px; margin:0px 45px;}
    .web-order-info-image ul li:hover { display: block;}
    .web-order-info-image ul li:hover a { display: block;}

    .web-order-info-integral { width:100%; height: 50px; margin-top:10px;}
        .web-order-info-integral-input { width:200px; height: 30px; border:1px solid #dfdfdf;}
            .web-order-info-integral-input input { width:190px; height:20px; border:0px; margin-top:5px; line-height:20px; font-size:12px; padding:0px 15px;}
        .web-order-info-integral-button { width:100px; height:30px; border:1px solid #d81e06; margin-left:10px;}
            .web-order-info-integral-button p { width:100px; cursor: pointer; height:30px;  text-align: center; line-height: 30px; justify-content:center; font-size:12px; color:#d81e06;}
  .web-cart-list-data { width:100%; height:auto; margin-top:0px; border-left:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf; border-right:1px solid #dfdfdf;}
 .web-cart-list-goods { width:210px; height:auto; line-height:40px; font-size:12px; flex-wrap:wrap; align-content:flex-start; color:#333333;}
  .web-cart-list-goods p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-goods a { width:100%; height:auto; line-height:20px; font-size:12px; color:#aaaaaa;}
  .web-cart-list-goods a:hover { color:#aaaaaa;}
  .web-cart-list-props {width:140px; height:auto; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-props p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-price {width:120px; height:auto; line-height:80px; font-size:12px; color:#333333;}
  .web-cart-list-price p { width:100%; height:auto; line-height:80px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-quantity { width:170px; height:auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; text-align: center;justify-content:center; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-quantity p { width:136px; height:40px; line-height:40px; overflow: hidden; flex-flow:row; justify-content:flex-start; margin-top:35px; border:1px solid #dfdfdf;}
  .web-cart-list-quantity p a { width: 40px; height: 40px; cursor: pointer; background: #efefef; font-size:28px; color:#333333; line-height:34px; text-align: center; justify-content:center;}
  .web-cart-list-quantity p input { width: 55px; height:38px; line-height:38px; text-align: center; font-size:12px; color:#333333; border:0px; min-height: 20px;}
  .web-cart-list-sum { width:120px; height:auto; line-height:40px; font-size:12px; color:#333333;}
  .web-cart-list-sum p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:12px; color:#333333;}
  .web-cart-list-action { width:100px; height:auto; line-height:40px; text-align: center; justify-content:center; font-size:12px; color:#333333;}
  .web-cart-list-action a { width:100%; height:auto; cursor: pointer; text-align: center; justify-content:center; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox img { width:80px; height:80px; cursor: pointer; margin:15px 0px 15px 15px;}

  .web-order-goods-box { width:100%; height:auto; margin-top:10px; border-top:1px solid #dfdfef; flex-wrap:wrap; align-content:flex-start;}

.web-order-footer { width:100%; height:auto; flex-wrap:wrap; margin-top:15px;  align-content:flex-start;}
    .web-order-footer ul { width:100%; height:auto; margin:0px; padding:0px 15px; flex-wrap:wrap; align-content:flex-start;}
    .web-order-footer ul.money {  height:90px; background: #f4f4f4; padding-top:15px; border-top:1px solid #dfdfdf;}
    .web-order-footer ul li { width:100%; height:30px;margin:0px; padding:0px; justify-content:flex-end;}
    .web-order-footer ul li p { width:70px; height:30px;margin:0px; padding:0px; line-height:30px; color:#333333; font-size:12px;}
    .web-order-footer ul li a { min-width:120px; height:30px; line-height:30px; color:#333333; font-size:12px; text-align: right; justify-content:flex-end;}
    .web-order-footer ul li a:hover { color:#333333;}
    .web-order-footer ul li a span { color:#999999; margin-left:5px;}
    .web-order-footer ul li a span.select { color:#E6A23C;}
    .web-order-footer ul li a.red { color:#d81e06; font-size:18px; font-weight: bold;}
    .web-order-footer h2 { width:100%; height:50px; margin-top:15px; justify-content:flex-end;}
    .web-order-footer h2 a {width:150px; height:40px; margin-left:15px; cursor: pointer;border: 1px solid #dfdfdf; line-height:38px; border-radius: 4px; text-align: center; justify-content:center; background: #ffffff; font-size:14px; color:#333333;}
    .web-order-footer h2 a:hover { color:#333333;}
    .web-order-footer h2 a.red { color:#ffffff; background: #d81e06;border: 1px solid #d81e06;}
    .web-order-footer h2 a.red:hover { color:#ffffff;}

#textarea { font-size:12px;}

</style>
<style>
.dropdown-toggle::after { position: absolute; top:13px; font-size:24px;}
</style>



// WEBPACK FOOTER //
// src/pages/order/sales_return.vue